import { useCallback } from 'react'

import { useLocalStorage } from 'usehooks-ts'

import { LocalStorageKey } from 'src/types'
import { deserializeMap, serializeMap } from 'src/utils'
import { LayoutMode } from 'src/utils/layout'

import { useIsGov } from '../../layouts/AppStateContextLayout/utils'

import { ApplicantSidebar } from './ApplicantSidebar/ApplicantSidebar'
import { StaffSidebar } from './StaffSidebar/StaffSidebar'

type Props = {
  layoutMode: LayoutMode
}
export const Sidebar = ({ layoutMode }: Props) => {
  const isGov = useIsGov()
  const [isNavGroupOpenMap, setAreNavItemsOpenMap] = useLocalStorage<Map<string, boolean>>(
    LocalStorageKey.NavigationRecordTypeIsOpenMap,
    new Map<string, boolean>(),
    {
      initializeWithValue: true,
      serializer: serializeMap,
      deserializer: deserializeMap,
    }
  )

  const handleToggleNavGroupIsOpen = useCallback(
    (key: string) => {
      setAreNavItemsOpenMap((prev) => {
        const next = new Map(prev)
        next.set(key, !next.get(key))
        return next
      })
    },
    [setAreNavItemsOpenMap]
  )

  return isGov ? (
    <StaffSidebar
      isNavGroupOpenMap={isNavGroupOpenMap}
      layoutMode={layoutMode}
      onToggleNavGroupIsOpen={handleToggleNavGroupIsOpen}
    />
  ) : (
    <ApplicantSidebar
      isNavGroupOpenMap={isNavGroupOpenMap}
      layoutMode={layoutMode}
      onToggleNavGroupIsOpen={handleToggleNavGroupIsOpen}
    />
  )
}
